export default __webpack_public_path__ + "static/logo-15-95913aa318c4699b5b0a11893856cd8b.png";